import { render, staticRenderFns } from "./CiSpec.vue?vue&type=template&id=33b80808&"
import script from "./CiSpec.vue?vue&type=script&lang=js&"
export * from "./CiSpec.vue?vue&type=script&lang=js&"
import style0 from "./CiSpec.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports